import { EmptyProps } from "@/Common/Components/BaseReactComponent";
import { MyleLogo } from "@/Common/Components/MyleLogo/MyleLogo";
import { Locale } from "@/Common/Models/Localization/Locale";
import * as LocalOperations from "@/Common/Operations/operations.local";
import { CanadaState } from "@/Common/Resources/Lookups/Enums/CommonLookupCodes";
import { LocalEvent } from "@/Common/Stores/Actions/LocalEvent";
import { sessionStore } from "@/Globals/Stores/SessionStore";

class HomeTabState {
    public lang: string;
}

class HomeTab extends React.Component<EmptyProps, HomeTabState> {
    constructor(props: EmptyProps) {
        super(props);

        var s = new HomeTabState();
        s.lang = sessionStore.userLanguageCode;
        this.state = s;
    }

    public render(): JSX.Element {
        return (
            <div className="workspace">
                <div className="myle-page-header home" />
                <div id="posref" className="ws-scrollable">
                    <div className="myle-doc-tb main-content myle-form documents">
                        {this.renderMyleTab()}
                    </div>
                </div>

                <div className="ws-footer" />
            </div>
        );
    }

    private showPhoneNumbers(): JSX.Element {
        const differentCountries = Array.from(new Set(sessionStore.ClinicActiveProvinces?.map(province => province.CountryLookupCode)));
        const differentStates = Array.from(new Set(sessionStore.ClinicActiveProvinces?.map(province => province.StateLookupCode)));

        if (differentCountries.length > 1 || differentStates.length > 1) {
            return (<></>);
        }

        // The lookupIds are hardcoded since there is no lookupProvider at this stage
        switch (differentStates?.[0]) {
            case CanadaState.Ontario:
                return (
                    <div><a href="tel:">{cacheStore.GetString("OntarioPhoneLabel")}</a></div>
                );
            case CanadaState.Quebec:
                return (
                    <div><a href="tel:">{cacheStore.GetString("QuebecPhoneLabel")}</a></div>
                );
            case CanadaState.BritishColumbia:
                return (
                    <div><a href="tel:">{cacheStore.GetString("BritishColumbiaPhoneLabel")}</a></div>
                );
            default:
                return (<></>);
        }
    }

    private renderMyleTab(): JSX.Element {
        const helpURL = `https://medfar.my.site.com/s/?language=${sessionStore.locale}`;

        let trackApplicationStatusURL;

        switch (sessionStore.locale) {
            case Locale.fr:
                trackApplicationStatusURL = "https://statut.medfarsolutions.com";
                break;
            case Locale.es:
                trackApplicationStatusURL = "https://estatus.medfarsolutions.com";
                break;
            default:
                trackApplicationStatusURL = "https://status.medfarsolutions.com";
        }

        return (
            <div>
                <div className="row">
                    <div className="col-lg-12 text-center">
                        <MyleLogo locale={sessionStore.locale} />
                    </div>
                </div>
                <div className="row">
                    <div className="col-lg-12 text-center">
                        {sessionStore.getCurrentEmployee()?.nameWithPrefix() && (
                            <div className="flex-container" style={{ justifyContent: "center", marginTop: "15px", marginBottom: "15px" }}>
                                <div>
                                    {cacheStore.GetString("ConnectedUserLabel")}
                                </div>
                                <div style={{ marginLeft: "7px", fontWeight: "bold" }}>
                                    {sessionStore.getCurrentEmployee()?.nameWithPrefix()}
                                </div>
                            </div>
                        )}
                        {sessionStore.isMsaActive && (
                            <div className="flex-container" style={{ justifyContent: "center", marginBottom: "15px" }}>
                                <div>
                                    {cacheStore.GetString("MsaIdLabel")}
                                </div>
                                <div style={{ marginLeft: "7px", fontWeight: "bold" }}>
                                    {sessionStore.msaId}
                                </div>
                            </div>
                        )}
                        <div>MYLE {sessionStore.versionNumber}</div>
                        <div />
                        <div className="margin-xs-top">
                            {this.showPhoneNumbers()}
                            <div><a href="tel:">{cacheStore.GetString("TollFreePhoneLabel")}</a></div>
                        </div>
                        <div><a href="mailto:support@medfarsolutions.com">support@medfarsolutions.com</a></div>
                        <div><a href={helpURL} target="_blank">{cacheStore.GetString("MyleHelpLabel")}</a></div>
                        <div><a href={trackApplicationStatusURL} target="_blank">{cacheStore.GetString("trackApplicationStatus")}</a></div>
                        <div className="f-row" style={{ textAlign: "center" }}>

                            <ul className="login-links clearfix">

                                {navigator.platform.toLowerCase().indexOf("win") >= 0 && (
                                    <li><span>&gt; </span><a href="https://download.teamviewer.com/download/TeamViewerQS.exe">{cacheStore.GetString("AllowRemoteContorlLabel")}</a></li>
                                )}

                                {navigator.platform.toLowerCase().indexOf("win") < 0 && (
                                    <li><span>&gt; </span><a href="https://download.teamviewer.com/download/TeamViewerQS.dmg">{cacheStore.GetString("AllowRemoteContorlLabel")}</a></li>
                                )}

                            </ul>

                        </div>
                    </div>
                </div>
                <div className="row">
                    <div className="col-lg-12 text-center">
                        <a onClick={this.onLogoutClick.bind(this)}> {cacheStore.GetString("LogoutLabel")}</a>
                    </div>
                </div>
            </div>
        );
    }

    private onLogoutClick(): void {
        if (cacheStore.ClinicSettings.EnableAIScribe && aiScribeStore.Model.get("ShowAIScribePopup")) {
            const operation = new LocalEvent(LocalOperations.AIScribe.ShowAIScribeWarningActiveAssistant);
            LocalEventDispatcher.dispatch(operation);
        }
        else {
            let op = new LocalEvent(LocalOperations.Login.OnLogout);
            LocalEventDispatcher.dispatch(op);
        }
    }
}

export { HomeTab };
